import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Logo from './Logo';
import { Button } from './ui/button';
import { Menu, X, KanbanSquare } from 'lucide-react';

export default function PublicNav() {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const links = [
    { label: 'Home', href: '#home' },
    { label: 'Services', href: '#services' },
    { label: 'Sectors', href: '#sectors' },
    { label: 'Process', href: '#process' },
    { label: 'About', href: '#about' },
    { label: 'Contact', href: '#contact' },
  ];
  return (
    <header className="sticky top-0 z-50 bg-white/85 backdrop-blur-xl border-b border-orange-100">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/"><Logo size="md" /></Link>
        <nav className="hidden lg:flex items-center gap-7">
          {links.map(l => (
            <a key={l.label} href={l.href} className="text-sm font-medium text-slate-700 hover:text-orange-600 transition-colors">{l.label}</a>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <Button variant="ghost" className="text-orange-800 hover:bg-orange-50" onClick={() => nav('/login')} data-testid="nav-sales-login">Sales Login</Button>
          <Button className="bg-emerald-700 hover:bg-emerald-800 text-white shadow-md shadow-emerald-200" onClick={() => nav('/login?next=/app/pipeline')} data-testid="nav-crm">
            <KanbanSquare className="w-4 h-4 mr-1.5" /> CRM
          </Button>
          <Button variant="ghost" className="text-amber-800 hover:bg-amber-50" onClick={() => nav('/login?role=admin')} data-testid="nav-admin-login">Admin Login</Button>
          <Button className="bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white shadow-md shadow-orange-200" onClick={() => nav('/login')}>Get Free Quote</Button>
        </div>
        <button className="lg:hidden p-2" onClick={() => setOpen(!open)} aria-label="menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-orange-100 bg-white px-5 py-4 space-y-3">
          {links.map(l => <a key={l.label} href={l.href} className="block text-sm font-medium text-slate-700" onClick={() => setOpen(false)}>{l.label}</a>)}
          <Button className="w-full bg-gradient-to-r from-orange-500 to-amber-500 text-white" onClick={() => nav('/login')}>Sales Login</Button>
          <Button className="w-full bg-emerald-700 hover:bg-emerald-800 text-white" onClick={() => nav('/login?next=/app/pipeline')}>
            <KanbanSquare className="w-4 h-4 mr-1.5" /> Open CRM
          </Button>
          <Button variant="outline" className="w-full border-amber-500 text-amber-800" onClick={() => nav('/login?role=admin')}>Admin Login</Button>
        </div>
      )}
    </header>
  );
}
